import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';
import { LoginService } from './login.service';
import { Token } from '../types/token';
import { ProductLine } from '../types/product-line';

@Injectable()
export class ColorService {

  constructor(
    private http: HttpClient
  ) { }

  getColors(): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.get(`${environment.api}api/colors`, {headers: headers});
  }

  getColorsByStyle(doorStyleId: string): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let searchParams: any = new Object();
    searchParams['styleId'] = doorStyleId;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const requestOptiosn = {headers, params: searchParams};
    return this.http.get(`${environment.api}api/colors/colorsbystyle`, requestOptiosn);
  }

  getColorsByDoorConstructionID(doorConstructionId: number): Observable<any> {
    let searchParams: any = new Object();
    searchParams['doorConstructionID'] = doorConstructionId;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const requestOptiosn = {headers, params: searchParams};
    return this.http.get(`${environment.api}api/colors/colorsbyconstruction`, requestOptiosn);
  }

  setNewColor(payload: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    return this.http.post(`${environment.apiQwikkitOrdering}api/Color/SetNewColor`, payload, {headers: headers});
  }
  
   getColorsByConstructionStyle(doorConstructionId: number, doorStyleId: number): Observable<any> {
    let searchParams: any = new Object();
    searchParams['doorConstructionID'] = doorConstructionId;
    searchParams['doorStyleID'] = doorStyleId;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const requestOptiosn = {headers, params: searchParams};
    return this.http.get(`${environment.api}api/colors/colorsbyconstructionstyle`, requestOptiosn);
  }
  

   getBackingColors(): Observable<any> {
  const headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      const requestOptions = {headers};   
      return this.http.get<Array<ProductLine>>(`${environment.apiQwikkitOrdering}api/DoorBacking/GetDoorBacking`, requestOptions);
  }

   getColorsByDoorBackingID(doorConstructionId: number, doorBackingId: number): Observable<any> {
    let searchParams: any = new Object();
    searchParams['doorConstructionID'] = doorConstructionId;
    searchParams['doorBackingId'] = doorBackingId;
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const requestOptions = {headers, params: searchParams};
    return this.http.get(`${environment.api}api/colors/getcolorsbyDoorBackingId`, requestOptions);
  }
}
